(function () {
  const section = document.querySelector('[data-press-section]');
  if (!section) return;

  initYearTabs(section);
  initAccordion(section);

  function initYearTabs(scope) {
    const buttons = Array.from(scope.querySelectorAll('[data-press-year]'));
    const groups = Array.from(scope.querySelectorAll('[data-press-year-group]'));
    if (buttons.length === 0) return;

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.pressYear;

        buttons.forEach((b) => b.classList.toggle('is-active', b === btn));
        groups.forEach((g) => {
          g.classList.toggle('is-hidden', g.dataset.pressYearGroup !== target);
        });

        closeAllRows(scope);
      });
    });
  }

  function initAccordion(scope) {
    const triggers = Array.from(scope.querySelectorAll('[data-press-row-trigger]'));

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const row = trigger.closest('[data-press-row]');
        if (!row) return;

        const isOpen = row.classList.contains('is-open');

        closeAllRows(scope);

        if (!isOpen) {
          row.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function closeAllRows(scope) {
    scope.querySelectorAll('[data-press-row].is-open').forEach((row) => {
      row.classList.remove('is-open');
      const trigger = row.querySelector('[data-press-row-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }
})();
